<template>
  <div id="app">
    <v-app>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-container style="margin-top: -5px">
            <v-layout align-center justify-center height="52px">
              <v-flex shrink>
                <span
                  style="
                    font-family: Fredoka One;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 43px;
                    line-height: 52px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    color: #18739d;
                    flex: none;
                    order: 3;
                    flex-grow: 0;
                    margin: 0px 0px;
                  "
                >
                  Continuous Age Estimation
                </span>
              </v-flex>
            </v-layout>
            <p class="subheading" style="text-align: center; margin-top: 1%">
              A demonstration of Privately's technology to continuosly estimate age from user's face.
            </p>
            <p class="subheading" style="text-align: center">
              For more information on how we process data, please refer to
              <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
            </p>
          </v-container>
          <v-container fluid fill-height style="margin-top: 5%">
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-container fluid fill-height>
                  <v-layout class="align-center justify-center">
                    <div style="text-align: center">
                      <span class="title custom-text">Press button to start continuous age estimation </span>
                      <p class="title custom-text" style="margin-top: 5px">
                        <span style="font-size: 30px">&#8681;</span>
                      </p>

                      <v-card
                        height="50"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#18739d"
                        style="border-radius: 10px"
                      >
                        <button
                          type="button"
                          class="button is-rounded"
                          style="color: white; border-radius: 15px"
                          :class="{ 'is-primary': !isCameraOpen, 'is-danger': isCameraOpen }"
                          @click="toggleCamera()"
                        >
                          <span v-if="!isCameraOpen" style="font-size: 16px">Open Camera</span>
                          <span v-else style="font-size: 16px">Close Camera</span>
                        </button>
                        <div id="myModal" class="modal">
                          <!-- Modal content -->
                          <div class="modal-content">
                            <span
                              class="close"
                              @click="
                                toggleCamera();
                                socketdisconnect();
                              "
                              >&times;</span
                            >
                            <span class="title custom-text" style="top: 40%"
                              >On Left hand side you will see the estimated age, environment condition and pose
                              estimation. Make sure none of them is in RED to get accurate age estimation
                            </span>

                            <div class="web-camera-container">
                              <!-- <div class="camera-button">
                                          <button type="button" class="button is-rounded" 
                                          :class="{ 'is-primary' : !isCameraOpen, 'is-danger' 
                                          : isCameraOpen}" @click="toggleCamera('1')">
                                              <span v-if="!isCameraOpen">Open Camera</span>
                                              <span v-else>Close Camera</span>
                                          </button>
                                      </div> -->

                              <div
                                v-if="isCameraOpen"
                                v-show="!isLoading"
                                class="camera-box"
                                style="max-width: 640px; min-width: 320px; min-height:240px max-height:480px; position: relative"
                              >
                                <video
                                  ref="video"
                                  autoplay
                                  style="position: relative; width: 100%; height: auto; margin-top: 0px"
                                ></video>
                                <!-- <canvas ref="canvas"></canvas> -->
                                <canvas
                                  ref="canvasoverlay"
                                  width="640px"
                                  height="480px"
                                  style="
                                    position: absolute;
                                    background: transparent;
                                    top: 0%;
                                    right: 0;
                                    bottom: 0;
                                    left: 0%;
                                  "
                                ></canvas>
                              </div>
                              <div flex class="analysis">
                                <div id="estimated_age">Estimated age: -</div>
                                <div id="lighting">Lighting: -</div>
                                <div id="blur">Blur: -</div>
                                <div id="head_tilt">Head_tilt: -</div>
                                <div id="head_left_right">Head_left_right: -</div>
                                <div id="head_up_down">Head_up_down: -</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>
  
  <script>
import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

// console.log("landed!");
var modal = document.getElementById("myModal");
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

export default {
  name: "ConitnuousAge",
  data() {
    return {
      loading: false,
      predictioncl: "",
      // api_url:"http://127.0.0.1:8082/",
      isCameraOpen: false,
      isLoading: false,
      socket: null,
      video: null,
      ctx_overlay: null,
      lines: [],
    };
  },
  methods: {
    socketconnect() {
      this.$socket = io("https://fallback-server-for-on-browser.privately.swiss:8998");
      // $socket is socket.io-client instance
      this.$socket.on("connect", () => {
        console.log("WebSocket connection established.");
        // captureVideo();
      });
    },
    socketdisconnect() {
      this.$socket.disconnect();
      // $socket is socket.io-client instance
      this.$socket.on("disconnect", () => {
        console.log("WebSocket disconnected.");
        // captureVideo();
      });
    },
    clickButton(data) {
      // $socket is socket.io-client instance
      this.$socket.emit("emit_method", data);
    },
    popupOpen() {
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    popupclose() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.stopCamera();
        this.popupclose();
      } else {
        this.isCameraOpen = true;
        this.socketconnect();
        this.startCamera();
        this.popupOpen();
      }
    },
    drawLines(coordinates) {
      const canvasoverlay = this.$refs.canvasoverlay;
      const video = this.$refs.video;
      this.$ctx_overlay = canvasoverlay.getContext("2d");
      // console.log("videoWidth"+)
      this.$ctx_overlay.width = video.offsetWidth;
      this.$ctx_overlay.height = video.offsetHeight;
      // console.log("Width = "+video.offsetWidth + "height:" +video.offsetHeight)
      this.$ctx_overlay.clearRect(0, 0, video.offsetWidth, video.offsetHeight);

      this.$ctx_overlay.beginPath();
      this.$ctx_overlay.setLineDash([3, 5]);
      this.$ctx_overlay.strokeStyle = "blue";
      this.$ctx_overlay.lineWidth = 0.1;

      for (let i = 0; i < coordinates.length; i++) {
        this.$ctx_overlay.moveTo(coordinates[i][0][0], coordinates[i][0][1]);
        this.$ctx_overlay.lineTo(coordinates[i][1][0], coordinates[i][1][1]);
        this.$ctx_overlay.stroke();
      }
    },
    updateResponse(data) {
      // canvas.width = video.videoWidth;
      // canvas.height = video.videoHeight;
      // const ctx_overlay = this.$canvas_overlay.getContext("2d");

      // // Draw bounding box
      // ctx.strokeStyle = 'red';
      // ctx.lineWidth = 2;

      this.drawLines(data["face_contours"]);

      // ctx.fillStyle = 'blue';
      // ctx.font = '16px Arial';
      if (data["estimated_age"] == "Bad Env/Pose") {
        document.getElementById("estimated_age").style.color = "red";
      } else {
        document.getElementById("estimated_age").style.color = "black";
      }
      document.getElementById("estimated_age").innerText = "Estimated age: " + data["estimated_age"];
      if (data["lighting"][0] == "good") {
        document.getElementById("lighting").style.color = "black";
      } else {
        document.getElementById("lighting").style.color = "red";
      }
      document.getElementById("lighting").innerText =
        "Lighting: " + data["lighting"][0] + "(" + data["lighting"][1] + ")";

      document.getElementById("blur").innerText = "Blur: " + data["blur"][0] + "(" + data["blur"][1] + ")";

      if (data["head_tilt"][0] == "straight") {
        document.getElementById("head_tilt").style.color = "black";
      } else {
        document.getElementById("head_tilt").style.color = "red";
      }
      document.getElementById("head_tilt").innerText =
        "Head_tilt: " + data["head_tilt"][0] + "(" + data["head_tilt"][1] + ")";
      if (data["head_left_right"][0] == "straight") {
        document.getElementById("head_left_right").style.color = "black";
      } else {
        document.getElementById("head_left_right").style.color = "red";
      }
      document.getElementById("head_left_right").innerText =
        "Head_left_right: " + data["head_left_right"][0] + "(" + data["head_left_right"][1] + ")";

      if (data["head_up_down"][0] == "straight") {
        document.getElementById("head_up_down").style.color = "black";
      } else {
        document.getElementById("head_up_down").style.color = "red";
      }
      document.getElementById("head_up_down").innerText =
        "Head_up_down: " + data["head_up_down"][0] + "(" + data["head_up_down"][1] + ")";
    },
    startCamera() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.videoStream = stream;
            this.$refs.video.srcObject = stream;
            this.startFrameRelay();
          })
          .catch((error) => {
            console.error("Error accessing camera:", error);
          });
      } else {
        console.error("getUserMedia is not supported");
      }
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => {
          track.stop();
        });
        this.$refs.video.srcObject = null;
        this.stopFrameRelay();
      }
    },

    startFrameRelay() {
      // Get the canvas element
      const canvas = this.$refs.canvasoverlay;
      const context = canvas.getContext("2d");

      // Create a new image every 100ms and send it to the server
      setInterval(() => {
        context.drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
        const imageData = canvas.toDataURL("image/jpeg");
        // Send the image data to the server via Socket.IO
        this.$socket.emit("image", { image: imageData });
        // requestAnimationFrame(sendFrame);
        this.$socket.on("image_resp", (data) => {
          console.log("Estimated Age: " + data["estimated_age"]);
          this.updateResponse(data);
        });
      }, 400);
    },
    stopFrameRelay() {
      // Disconnect from the Socket.IO server
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
    },

    resetpredictionlabel() {
      this.predictionResult = "--";
      this.predictionScore = " ";
      document.getElementById("prediction").style.color = "#000000";
    },
  },
};
</script>
  <style scoped>
.custom-text {
  font-family: Fredoka One;
  font-style: normal;
  font-weight: normal;
  font-size: 23px;
  line-height: 52px;
  text-align: center;
  color: #18739d;
  margin: 0px 0px;
}
.web-camera-container {
  margin-top: 5%;
  margin-bottom: 2rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  /* width: 500px; */
  position: relative;
}

.web-camera-container .camera-button {
  margin-bottom: 2rem;
}

.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  width: auto;
  height: auto;
  background-color: #fff;
  position: absolute;
}
.web-camera-container .camera-box .camera-shutter .flash {
  opacity: 1;
}

.camera-shoot {
  margin: 1rem 0;
}

.camera-shoot button {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.camera-shoot img {
  height: 35px;
  object-fit: cover;
}

.camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}

.camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}
.camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.camera-loading .loader-circle li :nth-child(2) {
  animation-delay: 0.2s;
}

.camera-loading .loader-circle li :nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes preload {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.analysis {
  /* position: relative;
   top:0;
   left:0;
   z-index: 3;
    */
  position: absolute;
  /* margin-top: 5%; */
  margin: 14px;
  top: 0;
  left: 0;
  padding: 10px;
  /* background-color: rgba(0, 0, 0, 0.1); */
  color: #fff;
  font-size: 13px;
  text-align: left;
  font-family: Helvetica;

  /* width: 200px; */
  /* height: 100%; */
  z-index: 3;
}
#estimated_age {
  color: black;
  font-weight: bold;
  background: lightgreen;
  width: 200px;
}
#lighting {
  color: black;
  background: lightblue;
  width: 200px;
}
#blur {
  color: black;
  background: lightblue;
  width: 200px;
}
#head_tilt {
  color: black;
  background: lightblue;
  width: 200px;
}
#head_left_right {
  color: black;
  background: lightblue;
  width: 200px;
}
#head_up_down {
  color: black;
  background: lightblue;
  width: 200px;
}
canvas {
  position: relative;
  /* top: 200;
  left: 200; */
  z-index: 2;
}
video {
  position: relative;
  /* top: 200;
  left: 200; */
  z-index: 1;
  /* display:none */
}
</style>
  
  
  